export { getProxyAgent, type ProxyAgentOptions } from './proxy-agent.ts';
